module.exports = __webpack_public_path__ + "img/btn_prostate_off.606d52fc.svg";